import styles from './ChatBoxStyle.module.css'

import { TextArea } from '@willphan1712000/frontend'
import { IoSend } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useState } from 'react'

type Props = {
  isOpen: boolean,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const ChatBox = ({ isOpen, setOpen } : Props) => {
  const [value, setValue] = useState<string|undefined>('')

  return (
    <div className={styles.background} style={{
      display: isOpen ? 'flex' : 'none'
    }}>
      <div className={styles.button} title='close chat' tabIndex={0} onClick={() => setOpen(prev => !prev)}>
        <IoClose size="25" />
      </div>
      <div className={styles.textArea}>
        <TextArea label='Ask anything' value={value} setValue={e => setValue(e)}/>
        <div className={styles.button} title='send' tabIndex={0}>
          <IoSend size="25" />
        </div>
      </div>
    </div>
  )
}

export default ChatBox
